export enum PerformanceRatingsEnum {
  NotSet = 0,
  Love = 1,
  Like = 2,
  Loathe = 3
}